// src/pages/Vouchers/BasicDataPage.js
//
// Minimal placeholder for voucher-domain basic data.
//
// IMPORTANT FOR I18N
// ------------------
// This page is intentionally still a placeholder, but even placeholder text is
// user-facing. Keeping it in the vouchers namespace avoids reintroducing hard-
// coded English while the module is waiting for future business functionality.

import React from "react";
import { useTranslation } from "react-i18next";
import "./BasicDataPage.css";

export default function BasicDataPage() {
  const { t } = useTranslation(["vouchers"]);

  return (
    <div className="basic-data-page" role="main">
      <h1>{t("vouchers:basicData.title")}</h1>
      <p>{t("vouchers:basicData.underDevelopment")}</p>
    </div>
  );
}
